import './styles.scss'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Toast } from 'primereact/toast'
import { Dialog } from 'primereact/dialog'
import apiAdapterCoffeeWeb from 'Services/apiAdapterCoffeeWeb'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import { commonMethods } from 'Utils/commonMethods'
import { DialogModal } from 'Components/UIComponents'
import Loader from 'Components/Loader'

const HistoryDataPopUp = ({ setLoading, selectedQualityForHistoryData, setSelectedQualityForHistoryData, mockHistoryDataPopUp, mockCoffeePriceHistoryData, mockSelectedHistoryDataIndex }) => {
  const [countryId, countryName, cropYear, qualityName, forexType, flagUrl, remarks, qualityGroup] = selectedQualityForHistoryData

  const { t } = useTranslation()
  const toast = useRef(null)

  const [coffeePriceHistoryData, setCoffeePriceHistoryData] = useState([])
  const [isDialogModalOpen, setIsDialogModalOpen] = useState(false)
  const [selectedHistoryDataIndex, setSelectedHistoryDataIndex] = useState(null)
  const [selectedHistoryData, setSelectedHistoryData] = useState({})

  const [modalState, setModalState] = useState({
    showModal: false,
    message: '',
    modalType: '',
    softAction: ''
  })

  useEffect(() => {
    document.body.style.overflow = isDialogModalOpen ? 'hidden' : ''

    return () => {
      document.body.style.overflow = ''
    }
  }, [isDialogModalOpen])

  useEffect(() => {
    if (selectedQualityForHistoryData?.length) {
      fetchHistoryData()
      setIsDialogModalOpen(false)

      setSelectedHistoryDataIndex(null)
    }
  }, [selectedQualityForHistoryData])

  useEffect(() => {
    if (!isDialogModalOpen) {
      setSelectedQualityForHistoryData([])
    }
  }, [isDialogModalOpen])

  // useEffect to initialize state for testing purpose
  useEffect(() => {
    if (mockHistoryDataPopUp) {
      setIsDialogModalOpen(mockHistoryDataPopUp)
      setCoffeePriceHistoryData(mockCoffeePriceHistoryData)
      setSelectedHistoryDataIndex(mockSelectedHistoryDataIndex)
    }
  }, [])

  const fetchHistoryData = async () => {
    setLoading(true)

    try {
      const response = await apiAdapterCoffeeWeb.getGlobalCoffeePriceHistoryData({ idCountry: countryId, countryName, cropYear, qualityName })

      if (response.data.returnLst?.length > 0) {
        setCoffeePriceHistoryData(response.data.returnLst[0].data)
        setIsDialogModalOpen(true)
      } else {
        showErrorToast('NO_DATA_FOUND')
        setCoffeePriceHistoryData([])
      }
    } catch (error) {
      showErrorToast('FAILED_TO_GET_DATA')
      setCoffeePriceHistoryData([])
    } finally {
      setLoading(false)
    }
  }

  const handleCloseModal = () => {
    setIsDialogModalOpen(false)
  }

  const showErrorToast = (message) => toast.current?.show({ severity: 'error', summary: 'Error', detail: t(message), life: 3000 })

  const priceColumnName = () => {
    if (!forexType) return ''

    const forexTypes = forexType.split(',').map((item) => item.replace(/INR\/|\/INR/g, '').trim())
    const result = [...new Set(forexTypes)]

    return `Prices in ${result} (${remarks})`
  }

  const priceForTheRemarks = () => {
    if (!remarks) return ''

    return `Prices in INR (${remarks})`
  }

  const handleClickEditButton = (index) => {
    setSelectedHistoryDataIndex(index)

    setSelectedHistoryData(coffeePriceHistoryData[index])
  }

  const handleInputChange = (e) => {
    const { value, name } = e.target

    setSelectedHistoryData((prev) => ({ ...prev, [name]: value }))
  }

  const handleClickSaveButton = async () => {
    const { id, uploadedDtm, cropYear, terminal, terminalLevel, rangeStart, rangeEnd, convertedRangeStart, convertedRangeEnd, remarks, forexValue } = selectedHistoryData

    const isEmpty = !uploadedDtm || !cropYear || !terminal || !terminalLevel || !rangeStart || !rangeEnd || !convertedRangeStart || !convertedRangeEnd || !remarks || !forexValue

    if (isEmpty) return

    setLoading(true)

    const payload = {
      id,
      idCountry: countryId,
      countryName,
      qualityGroup,
      qualityName,
      rangeStart,
      rangeEnd,
      remarks,
      cropYear,
      terminal,
      forexType,
      forexValue,
      terminalLevel,
      updatedDate: uploadedDtm,
      convertedRangeStart,
      convertedRangeEnd
    }

    try {
      const { data } = await apiAdapterCoffeeWeb.updateGlobalPriceData(payload)

      if (data?.isSuccess) {
        setCoffeePriceHistoryData((prevData) => {
          const updatedData = [...prevData]

          updatedData[selectedHistoryDataIndex] = selectedHistoryData

          return updatedData
        })

        setSelectedHistoryDataIndex(null)
      } else {
        setModalState({
          showModal: true,
          message: t('SOMETHING_WENT_WRONG'),
          modalType: 'error'
        })
      }
    } catch (error) {
      setModalState({
        showModal: true,
        message: t('FAILED_TO_EDIT_GLOBAL_RAW_COFFEE_PRICES'),
        modalType: 'error'
      })
    } finally {
      setLoading(false)
    }
  }

  const onDismissFunction = () => setModalState({ showModal: false })

  const onHide = () => setModalState({ showModal: false })

  const onSuccess = () => setModalState({ showModal: false })

  return (
    <>
      <Dialog className="edit-approved-raw-coffee-price-accordian-popup" header="Edit Raw Coffee history prices" visible={isDialogModalOpen} style={{ width: '95vw', height: '100vh' }} onHide={() => handleCloseModal()}>
        <div className="listedit-approved-global-coffee-price-popup-modal">
          <div className="global-coffee-price-popup-modal">
            <div className="global-raw-coffee-price-preview-table-wrapper">
              <table className="global-raw-coffee-price-preview-table">
                <thead className="global-raw-coffee-price-preview-table-header">
                  <tr>
                    <th colSpan={2} className="header-country">
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                        {t('COUNTRY')} : <img src={flagUrl} alt="Flag" className="flag-icon" /> {countryName}
                      </div>
                    </th>
                    <th colSpan={5} className="header-previous-data">
                      {t('PREVIOUS_DATA')}
                    </th>
                    <th colSpan={2} className="header-quality">
                      {qualityName}
                    </th>
                    <th></th>
                  </tr>
                  <tr>
                    <th rowSpan={2} className="accordion-date-tr">
                      {t('DATE')}
                    </th>
                    <th rowSpan={2}>{t('CROP_YEAR')}</th>
                    <th rowSpan={2}>{t('TERMINAL')}</th>
                    <th rowSpan={2}>{t('TERMINAL_LEVEL')}</th>
                    <th colSpan={2}>{priceColumnName()}</th>
                    <th rowSpan={2}>{forexType}</th>
                    <th colSpan={2}>{priceForTheRemarks()}</th>
                    <th></th>
                  </tr>
                  <tr>
                    <th colSpan={2} className="between-header">
                      {t('BETWEEN')}
                    </th>
                    <th colSpan={2} className="between-header">
                      {t('BETWEEN')}
                    </th>
                    <th>{t('ACTIONS')}</th>
                  </tr>
                </thead>

                {coffeePriceHistoryData.length > 0 ? (
                  <tbody className="global-raw-coffee-price-preview-table-body">
                    {coffeePriceHistoryData.length > 0 ? (
                      coffeePriceHistoryData.map(({ uploadedDtm, cropYear, terminal, terminalLevel, rangeStart, rangeEnd, forexValue, convertedRangeStart, convertedRangeEnd }, index) => {
                        const prevData = coffeePriceHistoryData[index + 1] || {}

                        return (
                          <tr key={index}>
                            <td className="date-td">{uploadedDtm}</td>
                            <td>{selectedHistoryDataIndex === index ? <InputText onChange={handleInputChange} value={selectedHistoryData.cropYear} name="cropYear" type="text" className="p-inputtext-sm" placeholder="Crop Year" /> : <>{cropYear}</>}</td>
                            <td className="terminal-data-value">{selectedHistoryDataIndex === index ? <InputText onChange={handleInputChange} value={selectedHistoryData.terminal} name="terminal" type="text" className="p-inputtext-sm" placeholder="Terminal" /> : <>{terminal}</>}</td>
                            <td className="terminal-data-value">{selectedHistoryDataIndex === index ? <InputText onChange={handleInputChange} value={selectedHistoryData.terminalLevel} name="terminalLevel" type="number" className="p-inputtext-sm" placeholder="Terminal Level" /> : <>{terminalLevel}</>}</td>

                            <td>{selectedHistoryDataIndex === index ? <InputText onChange={handleInputChange} value={selectedHistoryData.rangeStart} name="rangeStart" type="number" className="p-inputtext-sm" placeholder="Range Start" /> : <>{rangeStart}</>}</td>
                            <td>{selectedHistoryDataIndex === index ? <InputText onChange={handleInputChange} value={selectedHistoryData.rangeEnd} name="rangeEnd" type="number" className="p-inputtext-sm" placeholder="Range End" /> : <>{rangeEnd}</>}</td>
                            <td>{selectedHistoryDataIndex === index ? <InputText onChange={handleInputChange} value={selectedHistoryData.forexValue} name="forexValue" type="number" className="p-inputtext-sm" placeholder="Forex Value" /> : <>{forexValue}</>}</td>

                            <td className={convertedRangeStart >= (prevData.convertedRangeStart || 0) ? 'value-high' : 'value-low'}>{selectedHistoryDataIndex === index ? <InputText onChange={handleInputChange} value={selectedHistoryData.convertedRangeStart} name="convertedRangeStart" type="number" className="p-inputtext-sm" placeholder="Converted Range Start" /> : <>{convertedRangeStart}</>}</td>
                            <td className={convertedRangeEnd >= (prevData.convertedRangeEnd || 0) ? 'value-high' : 'value-low'}>{selectedHistoryDataIndex === index ? <InputText onChange={handleInputChange} value={selectedHistoryData.convertedRangeEnd} name="convertedRangeEnd" type="number" className="p-inputtext-sm" placeholder="Converted Range End" /> : <>{convertedRangeEnd}</>}</td>

                            <td style={{ width: '40px' }}>
                              {selectedHistoryDataIndex === index ? (
                                <div style={{ display: 'flex', gap: '0px' }}>
                                  <Button type="button" icon="pi pi-save" className="pi-save-icon" tooltip={t('SAVE')} onClick={() => handleClickSaveButton(index)} tooltipOptions={{ position: 'top' }} disabled={false} data-testid="save-button" />
                                  <Button type="button" icon="pi pi-times" className="pi-cancle-icon" tooltip={t('CANCEL')} onClick={() => setSelectedHistoryDataIndex(null)} tooltipOptions={{ position: 'top' }} disabled={false} data-testid="cancel-button" />
                                </div>
                              ) : (
                                <Button type="button" icon="pi pi-pencil" className="pi-edit-icon" tooltip={t('EDIT')} onClick={() => handleClickEditButton(index)} tooltipOptions={{ position: 'top' }} disabled={false} data-testid="edit-button" />
                              )}
                            </td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr></tr>
                    )}
                  </tbody>
                ) : (
                  <tbody className="global-raw-coffee-price-preview-table-body">
                    <tr>
                      <td className="no-data-found-td" colSpan={7} data-testid="no-data-found-td">
                        {t('NO_DATA_FOUND')}
                      </td>
                    </tr>
                  </tbody>
                )}
              </table>
            </div>
          </div>
          {coffeePriceHistoryData.length === 0 && <Toast ref={toast} />}
        </div>
      </Dialog>

      <DialogModal {...modalState} onDismiss={onDismissFunction} onRetry={commonMethods.handleRetry} onHide={onHide} onSuccess={onSuccess} onConfirmation={modalState?.confirmAction} />
    </>
  )
}

export default Loader(HistoryDataPopUp)
